import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
	CardBody,
	Card,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

//redux
import { values } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { addNewProductiveCycle, getProductiveCycleList, updateProductiveCycle, } from '../../../slices/productiveCycle/thunk';
import { setRequireCloseModal } from '../../../slices/productiveCycle/reducer';
import { setRequireCloseModal as setRequireCloseModalActivity } from '../../../slices/activity/reducer';
import { getCropTypeList, getEstablishmentList, getFeedingBargesList, getProductiveCycleStageList, getProductiveCycleStatusList, getSpeciesList, } from '../../../helpers/establishment/backend_helper';
import { getProductiveCycleStageTemplateList, addActivitiesProductiveCycle, getProductiveCycleActive, } from '../../../slices/thunks';
import { differenceInDays } from 'date-fns';
import { OTimelineBasic } from '../../../Components/General/Chart/OTimelineChart';
import useActivityTemplateItem from '../../../Components/Hooks/useActivityTemplateItemHooks';
import { addDays } from '../../../helpers/utils/functions';
import OSelect from '../../../Components/OElements/OSelect';
import moment from 'moment';

const ProductiveCycleForm = (props) => {
	const {
		dataProductiveCycle,
		isEdit,
		handleToggleModal,
		isOpen,
		activeTab,
		toggleTab,
		handleAllowConfigStages
	} = props;
	const dispatch = useDispatch();
	const { ActivityTemplateItemList } = useActivityTemplateItem();
	const [requireCloseModalFailActivity, setRequireCloseModalFailActivity] = useState(false);
	const [stageDates, setStageDates] = useState([]);
	const [series, setSeries] = useState([]);
	const [lastDate, setLastDate] = useState(null);
	const [disableSelectionFeedingBarge, setDisableSelectionFeedingBarge] = useState(true);

	const [selectedEstablishment, setSelectedEstablishment] = useState(null);
	const [selectedSpecies, setSelectedSpecies] = useState(null);
	const [selectedCropType, setSelectedCropType] = useState(null);
	const [selectedFeedingBarges, setSelectedFeedingBarges] = useState(null);
	const [selectedProductiveCycleStatus, setSelectedProductiveCycleStatus] = useState(null);
	const [withProductiveCycleActive, setWithProductiveCycleActive] = useState(false);
	const [conflictActive, setConflictActive] = useState(false);


	const est_type_codes_allow_feeding_barges = [
		'SWE'
	]

	const est_type_allow_many_species = [
		'FWE'
	]

	const est_type_codes_allow_config_stages = [
		'SWE'
	]

	const selectorActivity = createSelector(
		state => state.Activities,
		data => ({
			isAddingActivity: data.isAdding,
			isAddedActivity: data.isAdded,
			isUpdatingActivity: data.isUpdating,
			isUpdatedActivity: data.isUpdated,
			isLoadingListActivity: data.isLoadingList,
			requireCloseModalActivity: data.requireCloseModal,
		})
	);

	const { isAddingActivity, isUpdatingActivity, requireCloseModalActivity } =
		useSelector(selectorActivity);

	const selectorProductiveCycle = createSelector(
		state => state.ProductiveCycle,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
		})
	);
	const { isAdding, isAdded, isUpdating, isUpdated, isLoadingList, requireCloseModal, } = useSelector(selectorProductiveCycle);


	const selectorEstablishments = createSelector(
		state => state.Establishments,
		establishment => ({
			productive_cycle: establishment.productiveCycleActiveDetail,
			isLoading: establishment.isLoading,
			isSuccess: establishment.isSuccess,
			isError: establishment.isError,
		})
	);
	const { productive_cycle, isLoading, isSuccess, isError } = useSelector(selectorEstablishments);

	const selectorProductiveCycleStageTemplate = createSelector(
		state => state.ProductiveCycleStageTemplate,
		data => ({
			template: data.itemProductiveCycleStageTemplateList,
			tisAdding: data.isAdding,
			tisAdded: data.isAdded,
			tisUpdating: data.isUpdating,
			tisUpdated: data.isUpdated,
			tisLoadingList: data.isLoadingList,
			trequireCloseModal: data.requireCloseModal,
		})
	);
	const { template, tisAdding, tisAdded, tisUpdating, tisUpdated, tisLoadingList, trequireCloseModal, } = useSelector(selectorProductiveCycleStageTemplate);


	const validation = useFormik({
		enableReinitialize: true,
		validateOnMount: false, // Evita validaciones iniciales al cargar el formulario
		validateOnBlur: true, // Valida al perder el foco
		initialValues: {
			date_ini: dataProductiveCycle?.date_ini || '',
			date_end: dataProductiveCycle?.date_end || null,
			code: dataProductiveCycle?.code || '',
			establishment_id: dataProductiveCycle?.establishment_id || '',
			species_ids: dataProductiveCycle?.species_ids || [],
			productive_cycle_status_id: dataProductiveCycle?.productive_cycle_status_id || '',
			productive_cycle_stage_id: dataProductiveCycle?.productive_cycle_stage_id || '',
			disabled: dataProductiveCycle?.disabled || false,
			feeding_barges_ids: '',
			crop_type_id: dataProductiveCycle?.crop_type_id || '',
			date_range: [],
		},
		validationSchema: Yup.object({
			date_ini: Yup.string().required('Campo requerido'),
			// date_end: Yup.string().required('Campo requerido'),
			date_end: Yup.string().nullable(),
			// .when([], {
			// 	is: () => selectedEstablishment?.establishment_type?.code !== 'FWE',
			// 	then: schema => schema.required('Campo requerido'),
			// 	otherwise: schema => schema.notRequired(),
			// }),
			establishment_id: Yup.string().required('Campo requerido'),


			species_ids: Yup.array()
				.of(Yup.string())
				.min(1, 'Debe contener al menos un elemento')
				.required('Campo requerido'),

			// productive_cycle_status_id: Yup.string()
			// 	.test('conflict-active', 'Ya existe un ciclo productivo activo', function (value) {
			// 		return !(conflictActive && (!value || value.trim() === ''));
			// 	})
			// 	.required('Campo requerido'),

			productive_cycle_status_id: Yup.string().required('Campo requerido'),
			productive_cycle_stage_id: Yup.string().nullable(),
			feeding_barges_ids: Yup
				.array()
				.of(Yup.string())
				.nullable()
				.test('is_feeding_barge_selected', 'Campo requerido', value => {
					if (!disableSelectionFeedingBarge && !value) {
						return false;
					}
					return true;
				}),
			crop_type_id: Yup.string().required('Campo requerido'),
			date_range: Yup.array(),
		}),
		onSubmit: async values => {
			const formData = {
				...values,
				stages: stageDates,
				...(isEdit && { _id: dataProductiveCycle._id }),
			};


			if (selectedEstablishment?.establishment_type?.code === 'FWE') {
				if (formData.date_end === null) {
					delete formData.date_end; // Elimina el campo date_ini
				}
			}

			let cycle;
			if (isEdit) {
				cycle = await dispatch(updateProductiveCycle(formData));
			} else {
				cycle = await dispatch(addNewProductiveCycle(formData));
				try {
					const responseAddActivities = await dispatch(addActivitiesProductiveCycle(cycle.payload._id)).unwrap();
					cycle = await dispatch(updateProductiveCycle({
						...formData,
						success_creation_activities: true
					}));
				} catch (err) {
					setRequireCloseModalFailActivity(true);
					console.error('error: ', err);
				}

				dispatch(getProductiveCycleList());
				handleToggleModal();


				// // Helper function to format date to yyyy-mm-dd HH:mm:ss
				// const formatDateTime = (date, time) => {
				// 	const year = date.getFullYear();
				// 	const month = String(date.getMonth() + 1).padStart(2, '0');
				// 	const day = String(date.getDate()).padStart(2, '0');
				// 	return `${year}-${month}-${day} ${time}`;
				// };

				// const totalStages = stageDates.length;
				// let totalItems = 0;

				// // Calculate the total number of activities to be created
				// stageDates.forEach(stage => {
				// 	const { productive_cycle_stage_id } = stage;
				// 	const matchingItems = ActivityTemplateItemList.filter(item =>
				// 		// Check if any item.productive_cycle_stage_ids matches any stage productive_cycle_stage_id
				// 		item.productive_cycle_stage_ids.some(id => productive_cycle_stage_id.includes(id))
				// 	);
				// 	totalItems += matchingItems.length;
				// });

				// const toastId = toast('Creando actividades...', { autoClose: false });

				// let currentItem = 0;

				// stageDates.forEach((stage, stageIndex) => {
				// 	const { productive_cycle_stage_id, date_ini, establishment_id } = stage;
				// 	const matchingItems = ActivityTemplateItemList.filter(item => item.productive_cycle_stage_ids.some(id => productive_cycle_stage_id.includes(id)));

				// 	matchingItems.forEach((item, itemIndex) => {
				// 		const {
				// 			activity_group_id,
				// 			activity_status_id,
				// 			activity_priority_id,
				// 			activity_type_id,
				// 			activity_periodicity_id,
				// 			evidence_type_id,
				// 			supervisory_entity_id,
				// 			management_id,
				// 			obligation_id,
				// 			name,
				// 			summary,
				// 			days_duration
				// 		} = item;

				// 		const startDate = addDays(date_ini, days_duration ?? 0);
				// 		const activity = {
				// 			activity_group_id,
				// 			activity_status_id,
				// 			activity_priority_id,
				// 			activity_type_id,
				// 			activity_periodicity_id,
				// 			establishment_id: cycle.payload.establishment_id,
				// 			productive_cycle_id: cycle.payload._id,
				// 			productive_cycle_stage_id,
				// 			title: name,
				// 			summary,
				// 			start: formatDateTime(startDate, '09:00:00'),
				// 			end: formatDateTime(startDate, '10:00:00'),

				// 			evidence_type_id,
				// 			supervisory_entity_id,
				// 			obligation_id,
				// 			management_id
				// 		};

				// 		// Simulate the work being done in each iteration
				// 		setTimeout(async () => {
				// 			await dispatch(addNewActivity(activity));

				// 			currentItem++;
				// 			const progress = (currentItem / totalItems) * 100;

				// 			toast.update(toastId, {
				// 				render: `Creando actividad ${currentItem} de ${totalItems}`,
				// 				progress: progress / 100,
				// 				type: toast.TYPE.SUCCESS
				// 			});

				// 			if (currentItem === totalItems) {
				// 				toast.update(toastId, {
				// 					render: 'Actividades creadas',
				// 					type: toast.TYPE.SUCCESS,
				// 					autoClose: true
				// 				});
				// 			}
				// 		}, (stageIndex * matchingItems.length + itemIndex) * 100); // Adjust the delay as needed
				// 	});
				// });
			}
		},
	});




	const handleEstablishmentSelected = optionSelected => {
		if (optionSelected) {
			setSelectedEstablishment(optionSelected);
		}
		else {
			setSelectedEstablishment(null)
		}
	};

	const handleSpeciesSelected = optionSelected => {
		setSelectedSpecies(optionSelected);
	};

	const handleCropTypeSelected = optionSelected => {
		setSelectedCropType(optionSelected);
	};

	const handleFeedingBargesSelected = optionSelected => {
		setSelectedFeedingBarges(optionSelected);
	};

	const handleProductiveCycleStatusSelected = (optionSelected) => {
		if (optionSelected) {
			setSelectedProductiveCycleStatus(optionSelected);
		}
		else {
			setSelectedProductiveCycleStatus(null)
		}
	};


	useEffect(() => {
		handleValidateConflictActive();
	}, [selectedProductiveCycleStatus, withProductiveCycleActive]);



	useEffect(() => {
		if (selectedEstablishment) {
			dispatch(getProductiveCycleActive(selectedEstablishment?._id));
		}
	}, [selectedEstablishment]);

	useEffect(() => {
		setWithProductiveCycleActive(productive_cycle?.productive_cycle_status?.code === 'AC');
	}, [productive_cycle]);

	const handleValidateConflictActive = () => {
		if (selectedProductiveCycleStatus?.code == 'AC' && withProductiveCycleActive) {
			setConflictActive(true)
		}
		else {
			setConflictActive(false)
		}
	}





	useEffect(() => {
		if (isOpen) {
			if (!isEdit) {
				if (requireCloseModal && (requireCloseModalActivity || requireCloseModalFailActivity)) {
					dispatch(setRequireCloseModal(false));
					dispatch(setRequireCloseModalActivity(false));
					setRequireCloseModalFailActivity(false);
					handleToggleModal();
				}
			} else {
				if (requireCloseModal) {
					dispatch(setRequireCloseModal(false));
					handleToggleModal();
				}
			}
		}
	}, [
		requireCloseModal,
		requireCloseModalActivity,
		requireCloseModalFailActivity
	]);

	useEffect(() => {
		if (selectedEstablishment && selectedSpecies) {
			const region_id = selectedEstablishment.region_id;
			const specie_ids = (
				selectedSpecies?.length
					? selectedSpecies.map(specie => specie.item._id).join(',')
					: ''
			);
			dispatch(
				getProductiveCycleStageTemplateList({
					region_id: region_id,
					specie_ids: specie_ids
				})
			);
		}
	}, [selectedEstablishment, selectedSpecies]);

	const calculateStagesDates = () => {
		if (!validation.values.date_ini) return [];

		let startDate = validation.values.date_ini;
		return template.map(item => {
			const endDate = addDays(startDate, item.days);
			const result = {
				...item,
				date_ini: startDate,
				date_end: endDate,
				days: item.days,
			};
			startDate = endDate;
			setLastDate(endDate);
			return result;
		});
	};

	const buildSeries = stageDates => {
		return [
			{
				data: stageDates.map(item => ({
					x: item.productive_cycle_stage.name,
					y: [
						new Date(item.date_ini).getTime(),
						new Date(item.date_end).getTime(),
					],
				})),
			},
		];
	};

	// useEffect(() => {
	// 	if (dataProductiveCycle) {
	// 		validation.setFieldValue(
	// 			'date_ini',
	// 			dataProductiveCycle.date_ini || ''
	// 		);
	// 	}
	// }, [dataProductiveCycle]);

	useEffect(() => {
		if (!disableSelectionFeedingBarge) {
			setStageDates(calculateStagesDates());
		}
	}, [template, validation.values.date_ini]);

	useEffect(() => {
		if (selectedEstablishment?.code_siep && validation.values.date_ini) {
			const code = `${selectedEstablishment.code_siep}-${moment(validation.values.date_ini).format('YYYYMM')}`;
			validation.setFieldValue('code', code); // Actualiza el valor de 'code'
		}
		else {
			validation.setFieldValue('code', null);
		}
	}, [selectedEstablishment, validation.values.date_ini]);




	useEffect(() => {
		setSeries(buildSeries(stageDates));
	}, [stageDates]);


	useEffect(() => {
		validation.values.date_end = lastDate;
	}, [lastDate]);

	const handleStageChange = (index, field, value) => {
		const newStages = [...stageDates];
		newStages[index][field] = value;

		if (field === 'date_ini' || field === 'date_end') {
			const iniDate = new Date(newStages[index].date_ini);
			const endDate = new Date(newStages[index].date_end);
			newStages[index].days = differenceInDays(endDate, iniDate) + 1;
		} else if (field === 'days') {
			let date_ini = new Date(newStages[index].date_ini);
			newStages[index].date_end = addDays(date_ini, value);
		}

		setStageDates(newStages);
	};


	useEffect(() => {
		// if (!selectedEstablishment?.establishment_type?.code) {
		// 	// clean species selected
		// 	validation.setFieldValue('species_ids', []);
		// }

		if (
			selectedEstablishment?.establishment_type?.code &&
			est_type_codes_allow_config_stages.includes(
				selectedEstablishment?.establishment_type?.code
			)
		) {
			handleAllowConfigStages(true);
		} else {
			handleAllowConfigStages(false);
		}

		if (
			(
				selectedEstablishment?.establishment_type?.code &&
				est_type_codes_allow_feeding_barges.includes(
					selectedEstablishment?.establishment_type?.code
				)
			)
		) {
			setDisableSelectionFeedingBarge(false);
		} else {
			validation.setFieldValue('feeding_barges_ids', '');
			setDisableSelectionFeedingBarge(true);
		}
	}, [selectedEstablishment])

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						{/* {conflictActive ? (
							<Row className='g-3'>
								<Col lg={12}>
									<div className="alert alert-danger alert-dismissible alert-label-icon rounded-label fade show mt-3" role="alert">
										<i className={`${Icons.alert} label-icon`}></i> Ya existe un ciclo productivo activo para este establecimiento. Antes de continuar, verifique el estado del ciclo en curso para evitar posibles conflictos en la gestión de la información.
									</div>
								</Col>
							</Row>
						) : null} */}
						<Row className='g-3'>
							<Col lg={3}>
								<Label for='code' className='form-label'>
									Código del Ciclo
								</Label>
								<Input
									name='code'
									id='code'
									value={validation.values.code || ''}
									className='form-control'
									placeholder='Código del Ciclo'
									type='text'
									disabled={true}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key={
										`establishment_id${values.establishment_id}` || ''
									}
									label='Establecimiento'
									id='establishment_id'
									name='establishment_id'
									isRequired={true}
									value={validation.values.establishment_id || ''}
									onSelect={handleEstablishmentSelected}
									requestApi={() => getEstablishmentList({ with_productive_cycle: true })}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key={`feeding_barges_ids` || ''}
									label='Artefacto Naval'
									id='feeding_barges_ids'
									name='feeding_barges_ids'
									value={dataProductiveCycle?.feeding_barges_ids || ''}
									onSelect={setSelectedFeedingBarges}
									requestApi={() => getFeedingBargesList({})}
									validation={validation}
									disabled={disableSelectionFeedingBarge}
									isMulti
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key={`crop_type_id${values.crop_type_id}` || ''}
									label='Tipo Cultivo'
									id='crop_type_id'
									name='crop_type_id'
									isRequired={true}
									value={validation.values.crop_type_id || ''}
									onSelect={setSelectedCropType}
									requestApi={() => getCropTypeList({})}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key={`species_ids`}
									label='Especie'
									id='species_ids'
									name='species_ids'
									isRequired={true}
									value={validation.values.species_ids || ''}
									// onSelect={setSelectedSpecies} 
									onSelect={(selected) => {
										const values = selected.map(item => item.value);
										validation.setFieldValue('species_ids', values);
									}}
									requestApi={() => getSpeciesList({})}
									validation={validation}
									isMulti
									maxSelectedValues={(
										(
											selectedEstablishment?.establishment_type?.code &&
											est_type_allow_many_species
												.includes(selectedEstablishment?.establishment_type?.code))
											? false
											: true
									)
									}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key={
										`productive_cycle_status_id${values.productive_cycle_status_id}` ||
										''
									}
									label='Estado'
									id='productive_cycle_status_id'
									name='productive_cycle_status_id'
									isRequired={true}
									value={
										validation.values.productive_cycle_status_id || ''
									}
									onSelect={handleProductiveCycleStatusSelected}
									requestApi={() => getProductiveCycleStatusList({})}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key={`productive_cycle_stage_id${values.productive_cycle_stage_id}` || ''}
									label='Etapa Activa'
									id='productive_cycle_stage_id'
									name='productive_cycle_stage_id'
									value={
										validation.values.productive_cycle_stage_id || ''
									}
									// onSelect={setSelectedProductiveCycleStatus}
									requestApi={() => getProductiveCycleStageList({})}
									validation={validation}
								/>
							</Col>
							<Col sm={3}>
								<DatesProvider
									settings={{
										locale: 'es-mx',
										firstDayOfWeek: 1,
										weekendDays: [0],
										timezone: 'UTC',
									}}
								>
									<DatePickerInput
										label={
											<span>
												Fecha Inicio Ciclo <span style={{ color: 'red' }}>*</span>
											</span>
										}
										id='date_ini'
										name='date_ini'
										placeholder='Seleccione una fecha'
										value={
											validation.values.date_ini
												? new Date(validation.values.date_ini)
												: null
										}
										onChange={date => {
											validation.setFieldValue(
												'date_ini',
												date || null
											);
										}}
										onBlur={validation.handleBlur}
										valueFormat='DD-MM-YYYY'
										error={
											validation.touched.date_ini &&
												validation.errors.date_ini
												? validation.errors.date_ini
												: ''
										}
										clearable
									/>
								</DatesProvider>
							</Col>
							<Col sm={3}>
								<DatesProvider
									settings={{
										locale: 'es-mx',
										firstDayOfWeek: 1,
										weekendDays: [0],
										timezone: 'UTC',
									}}
								>
									<DatePickerInput
										label={
											<span>
												Fecha Término Ciclo
											</span>
										}
										id='date_end'
										name='date_end'
										placeholder='Seleccione una fecha'
										value={
											validation.values.date_end
												? new Date(validation.values.date_end)
												: null
										}
										onChange={date => {
											validation.setFieldValue(
												'date_end',
												date || null
											);
										}}
										onBlur={validation.handleBlur}
										valueFormat='DD-MM-YYYY'
										error={
											validation.touched.date_end &&
												validation.errors.date_end
												? validation.errors.date_end
												: ''
										}
										clearable
									/>
								</DatesProvider>
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId='2'>
						<Row className='g-3'>
							{stageDates &&
								stageDates.map((item, key) => (
									<React.Fragment key={key}>
										<Col lg={3}>
											<Label for='stage' className='form-label'>
												Etapa
											</Label>
											<Input
												name='stage'
												id={`stage${key}`}
												className='form-control'
												type='text'
												disabled={true}
												value={item.productive_cycle_stage.name}
											/>
										</Col>
										<Col lg={3}>
											<Label for='days' className='form-label'>
												Días
											</Label>
											<Input
												name='days'
												id={`days${key}`}
												className='form-control'
												type='number'
												value={item.days}
												onChange={e =>
													handleStageChange(
														key,
														'days',
														e.target.value
													)
												}
											/>
										</Col>
										<Col lg={3}>
											<Label for='date_ini' className='form-label'>
												Inicio
											</Label>
											<DatePickerInput
												id={`date_ini${key}`}
												value={
													item.date_ini
														? new Date(item.date_ini)
														: null
												}
												onChange={date =>
													handleStageChange(key, 'date_ini', date)
												}
												valueFormat='DD-MM-YYYY'
												clearable
											/>
										</Col>
										<Col lg={3}>
											<Label for='date_end' className='form-label'>
												Término
											</Label>
											<DatePickerInput
												id={`date_end${key}`}
												value={
													item.date_end
														? new Date(item.date_end)
														: null
												}
												onChange={date =>
													handleStageChange(key, 'date_end', date)
												}
												valueFormat='DD-MM-YYYY'
												clearable
											/>
										</Col>
									</React.Fragment>
								))}
						</Row>
						<Row className='g-3'>
							<Col lg={12} className='pt-3'>
								<OTimelineBasic
									dataColors='["--vz-primary"]'
									series={series}
									height={250}
									title={'Gantt'}
									x_title={'Fechas'}
									y_title={'Etapas'}
								/>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 modal-footer-add-btn'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isAddingActivity || isUpdating || isUpdatingActivity }
					>
						{isAdding ||
							isAddingActivity ||
							isUpdating ||
							isUpdatingActivity ?
							(<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
						{isEdit ? 'Editar' : 'Crear'} Ciclo Productivo
					</button>
				</div>
			</div>
		</Form>
	);
};

export default ProductiveCycleForm;
